<div class="popup__premiacao" *ngIf="exibePopupGanhadorPromocao">
  <lovers-popup [exibir]="exibePopupGanhadorPromocao" tamanho="imagem">
    <img
      class="pascoa__sorteado"
      (click)="irParaResultado()"
      src="assets/images/promocao/Namorados23_LP_Desktop-Popup_v1.png"
      alt="Ganhador Dia dos Namorados 2023"
    />
    <img
      class="pascoa__sorteado__mobile"
      (click)="irParaResultado()"
      src="assets/images/promocao/Namorados23_LP_Mobile-Popup_v1.png"
      alt="Ganhador Dia dos Namorados 2023"
    />
    <!-- <button class="sorteado__button" (click)="irParaResultado()">
      Ver resultado
    </button> -->
  </lovers-popup>
</div>

<!-- <lovers-popup
  [exibir]="exibePopupAceiteComunicacao"
  *ngIf="exibePopupAceiteComunicacao"
  tamanho="pequeno"
  (onClose)="fecharPopupAceiteComunicacao()"
>
  <div class="popup__header">
    <p class="header__title"></p>
  </div>
  <div class="popup__body">
    <div class="align__center angular-with-newlines">
      <dynamic-form
        [fields]="regConfigPopupAceiteComunicacao"
        (submit)="submit($event)"
      ></dynamic-form>
    </div>
  </div>
</lovers-popup> -->

<lovers-popup
  id="modal-window-popupAvisoHome"
  [exibir]="exibePopupAvisoHome"
  [exibirBotaoFechar]="exibeBotaoFecharAvisoHome"
  *ngIf="exibePopupAvisoHome"
  tamanho="pequeno"
>
  <div class="popup__header">
    <p class="header__title"></p>
  </div>
  <div class="popup__body">
    <div class="align__center angular-with-newlines">
      <dynamic-form
        [fields]="regAbrirFecharPopupAvisoHome"
        (submit)="submit($event)"
      ></dynamic-form>
    </div>
  </div>
</lovers-popup>

<lovers-popup tamanho="grande" id="modal-window-regulamento" [exibir]="false">
  <div class="popup__header">
    <p class="header__title"></p>
  </div>
  <div class="popup__body">
    <div class="align__center angular-with-newlines">
      <dynamic-form [fields]="regConfigPopupRegulamento"></dynamic-form>
    </div>
  </div>
</lovers-popup>

<div class="notificacao-modal">
  <lovers-popup
    tamanho="pequeno"
    id="modal-notificacao"
    [exibir]="exibePopupNotificacao"
    (onClose)="exibePopupNotificacao = false"
    *ngIf="this.notificacao"
  >
    <div (click)="onClickNotificacao(notificacao)">
      <img
        class="img__notificacao"
        [ngClass]="{ notificacao__desktop: notificacao.caminhoImagemMobile }"
        [src]="notificacao.caminhoImagem"
        alt=""
      />
      <img
        *ngIf="notificacao.caminhoImagemMobile"
        class="img__notificacao notificacao__mobile"
        [src]="notificacao.caminhoImagemMobile"
        alt=""
      />
    </div>

    <div class="notificao__fechar">
      <button class="lovers-button" (click)="exibePopupNotificacao = false">
        Fechar
      </button>
    </div>
  </lovers-popup>
</div>

<lovers-popup
  [exibir]="exibirExplicacaoNiveis"
  (onClose)="exibirExplicacaoNiveis = false"
  *ngIf="membro !== undefined"
  [blockOverflow]="true"
>
  <div class="popup__header">
    <p class="header__title font__family--belluga">
      Oi,
      <span class="font__family--belluga">{{ membro.descricaoNivel }}</span>
    </p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <p class="descricao__texto">
        Os níveis são definidos com base no
        <strong>acumulado do seu consumo dos últimos 12 meses</strong> em nossos
        produtos e serviços.
        <b
          >Ganhe 1 ponto a cada R$ 1,00 em compras feitas em nossas lojas e em
          nosso site.</b
        >
      </p>
      <p class="descricao__texto">
        <strong>Suba de nível para evoluir em nosso relacionamento</strong> e
        desbloquear novos momentos especiais para resgate. Veja abaixo a
        pontuação mínima em cada nível:
      </p>
    </div>

    <img class="imagem__niveis" src="assets/images/others/barNiveis.png" />
    <img
      class="imagem__niveis--mobile"
      src="../../../../assets/images/others/barraNiveisMobile.png"
    />

    <p class="descricao__missoes">
      Participe das missões para ganhar ainda mais pontos e subir de nível mais
      rapidamente.
    </p>
    <p class="descricao__importante">
      <strong>Importante:</strong> Os pontos são válidos somente para avanço de
      nível, que possibilitam o desbloqueio de novos momentos e benefícios.
    </p>
  </div>
</lovers-popup>

<lovers-popup
  tamanho="pequeno"
  [exibir]="exibePopupAvisoVencimentoCacaus"
  (onClose)="exibePopupAvisoVencimentoCacaus = false"
  *ngIf="this.resumoVencimentoCacaus"
>
  <div class="popup__header">
    <p class="header__title">Hey, Lover! Seus Cacaus estão expirando.</p>
  </div>
  <div class="popup__body" style="padding: initial">
    <div class="descricao" style="margin: inherit">
      <p class="descricao__texto_vencimento">
        Você tem
        <b>{{ this.resumoVencimentoCacaus?.somaCacau }} Cacaus</b> expirando nos
        próximos 30 dias.
      </p>
      <p class="descricao__texto_vencimento">
        Que tal usá-los para resgatar uma super experiência?
      </p>

      <div class="div__informativo_vencimentos">
        <div>
          <p class="texto__proximo_vencimento">Seu proximo vencimento é de:</p>
          <div class="descricao__texto_vencimento grid__vencimento">
            <div style="margin-right: 7px">
              <img
                class="pontos__icone"
                src="assets/images/icons/cacau_moeda.png"
              />
            </div>
            <div style="margin-right: 11px">
              <b>{{ this.resumoVencimentoCacaus?.cacaus }} Cacaus</b>
            </div>
            <div class="data__vencimento">
              <b>{{ this.resumoVencimentoCacaus?.validade }}</b>
            </div>
          </div>
        </div>
        <div>
          <a
            class="lovers-button"
            (click)="
              redirecionarMomentosEspeciais(this.membro?.saldo?.saldoPontos)
            "
          >
            <img src="assets/images/icons/cacau_moeda.png" /> Usar meus cacaus
          </a>
        </div>
      </div>
    </div>
  </div>
</lovers-popup>

<main id="index" class="lovers__index">
  <div class="subheader">
    <div
      class="subheader__nivel nivel__loader loader--desktop"
      *ngIf="carregandoMembro"
    >
      <!-- <div class="nivel__progresso">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            'border-radius': '134px',
            width: '180px',
            height: '180px',
            margin: '-30px 8px auto 16px',
            display: 'block',
            marginBottom: '32px'
          }"
        ></ngx-skeleton-loader>
      </div> -->
      <div class="nivel__descricao">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '350px',
            height: '40px',
            marginBottom: '12px'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '625px',
            height: '24px',
            display: 'block'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '625px',
            height: '24px',
            display: 'block'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <div
      class="subheader__nivel nivel__loader loader--mobile"
      *ngIf="carregandoMembro"
    >
      <div class="nivel__descricao">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '270px',
            height: '20px',
            marginTop: '120px',
            marginLeft: '82px'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '300px',
            height: '12px',
            display: 'block',
            margin: '10px 0 3px 70px'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '300px',
            height: '22px',
            display: 'block',
            margin: '10px 0 3px 70px'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <div
      class="subheader__nivel"
      *ngIf="membro !== undefined && !carregandoMembro"
    >
      <div class="nivel__progresso">
        <!-- <lovers-circular-progress-bar [legenda]="membro.descricaoNivel" [exibirValorAtual]="true"
          [exibirValorTotal]="false" [exibirSeparador]="false" [valorAtual]="membro.saldo.saldoXP"
          [valorTotal]="membro.nivelRange.proximoXP" [porcentagem]="membro.nivelRange.porcentagemNivel"
          unidadeMedida="pontos" [exibirFundoPreto]="true"></lovers-circular-progress-bar> -->
        <app-niveis-progress-bar
          [membro]="membro"
          [legenda]="membro.descricaoNivel"
          [idNivel]="membro.idNivel"
          [valorAtual]="membro.saldo.saldoXP"
          [valorTotal]="membro.nivelRange.proximoXP"
          [porcentagem]="membro.nivelRange.porcentagemNivel"
          [pontosRestantes]="membro.nivelRange.pontosRestantesProximoNivel"
          (exibirExplicacaoNiveis)="receberPopUpEntendaNiveis($event)"
        ></app-niveis-progress-bar>
      </div>
      <!-- <div class="nivel__descricao">
        <p class="descricao__titulo">
          Você é
          {{
          membro.descricaoNivel[membro.descricaoNivel.length - 1] === "a"
          ? "nossa"
          : "nosso"
          }}
          <span class="lovers-font--leahlee">{{ membro.descricaoNivel }} &lt;3</span>
        </p>
        <p class="descricao__acumule" *ngIf="membro.idNivel != 9">
          Suba de nível para evoluir em nosso relacionamento e desbloquear novas
          experiências para resgate.
        </p>
        <p class="descricao__entenda" (click)="abrirEntendaNiveis()">
          Entenda os níveis<svg class="icone__entenda" width="10" height="17" viewBox="0 0 10 17" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M2 15.1016L8 8.76956L2 2.4375" stroke="#FF9999" stroke-width="3" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </p>
      </div> -->
    </div>

    <div class="subheader__card__cacaus" *ngIf="!carregandoConteudos">
      <cacaus-card
        *ngIf="membro"
        [pontuacao]="membro.saldo.saldoPontos"
        [redirectExtrato]="true"
        [idNivel]="membro.idNivel"
        [legenda]="membro.descricaoNivel"
      ></cacaus-card>
    </div>
    <div
      class="subheader__card__cacaus loader--desktop"
      *ngIf="carregandoConteudos"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '315px',
          height: '159px',
          'border-radius': '24px'
        }"
      ></ngx-skeleton-loader>
    </div>

    <div
      class="subheader__card__cacaus loader--mobile"
      *ngIf="carregandoConteudos"
    >
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          width: '327px',
          height: '80px',
          'border-radius': '24px'
        }"
      ></ngx-skeleton-loader>
    </div>
    <!-- <img
      class="subheader__background"
      src="assets/images/backgrounds/background_topo.png"
    /> -->
  </div>

  <div *ngIf="membro?.diasDeVida" class="div__dias_de_vida">
    <img src="assets/images/icons/star.svg" alt="Estrela" />
    <p>Hoje é o seu dia {{ formatNumber(membro.diasDeVida) }} de vida</p>
    <img src="assets/images/icons/feliz_hoje_dias_de_vida.svg" alt="" />
    <img src="assets/images/icons/star.svg" alt="Estrela" />
  </div>

  <div
    class="conteudo__carrossel carrossel--desktop"
    *ngIf="!carregandoConteudos"
  >
    <app-carousel-dinamico
      *ngIf="listaConteudos.length > 0"
      [lista]="listaConteudos"
    ></app-carousel-dinamico>
  </div>

  <div
    class="conteudo__carrossel carrossel--mobile"
    *ngIf="!carregandoConteudos"
  >
    <app-carousel-dinamico
      *ngIf="listaConteudosMobile.length > 0"
      [lista]="listaConteudosMobile"
    >
    </app-carousel-dinamico>
  </div>

  <div class="carrossel__loader loader--desktop" *ngIf="carregandoConteudos">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        'border-radius': '32px',
        width: '95%',
        height: '300px',
        display: 'block',
        margin: '0 auto 32px'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div class="carrossel__loader loader--mobile" *ngIf="carregandoConteudos">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        'border-radius': '32px',
        width: '95%',
        height: '150px',
        display: 'block',
        margin: '0 auto 32px'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div class="desafios">
    <div class="desafios__header__missoes">
      <img src="assets/images/logos/missaoLovers.svg" alt="Missões Lovers" />
    </div>
    <div class="desafios__header">
      <div
        class="header__text"
        *ngIf="
          this.desafios.length != 0 &&
          !carregandoDesafios &&
          membro !== undefined
        "
      >
        <div class="header__ver_todos" (click)="irParaVerDesafios()">
          <p class="ver_todos_titulo">Ver todas</p>
          <img
            class="ver_todos_icone"
            [ngClass]=""
            src="assets/images/icons/seta_baixo.png"
          />
        </div>
        <span class="header__subtitulo"
          >Conclua as missões e ganhe
          <p>recompensas!</p>
        </span>
      </div>
    </div>
    <div
      class="desafios__loader"
      *ngIf="carregandoDesafios || membro === undefined"
    >
      <ngx-skeleton-loader
        *ngFor="let i of [1, 2, 3]"
        [theme]="{
          'border-radius': '24px',
          width: '380px',
          height: '170px'
        }"
      ></ngx-skeleton-loader>
    </div>
    <div
      *ngIf="
        desafios.length == 0 && !carregandoDesafios && membro !== undefined
      "
      class="desafios__zerados"
    >
      <h1>Novas missões estão chegando!</h1>
      <p>Fique atento, a qualquer momento novas missões estarão disponíveis.</p>
      <shared-button-lovers
        [width]="255"
        [height]="40"
        [idButton]="'verMissoes'"
        [type]="'button'"
        [variant]="'primary'"
        [label]="'Ver missões passadas'"
        (onClick)="irParaVerDesafios()"
      ></shared-button-lovers>
    </div>
    <div
      *ngIf="desafios.length > 0 && !carregandoDesafios && membro !== undefined"
      id="desafios-cards"
      class="desafios__cards"
      #elem
      (mousedown)="startDragging($event, false, elem)"
      (mouseup)="stopDragging($event, false)"
      (mouseleave)="stopDragging($event, false)"
      (mousemove)="moveEvent($event, elem)"
    >
      <lovers-card-desafio
        *ngFor="let desafio of desafios; let i = index"
        [desafioId]="desafio.id"
        [titulo]="desafio.titulo"
        [descricao]="desafio.descricao"
        [valorPontosRecompensa]="desafio.valorPontosRecompensa"
        [valorCacausRecompensa]="desafio.valorCacausRecompensa"
        [inicioDesafio]="desafio.inicioDesafio"
        [desafioAceito]="desafio.desafioAceito"
        [fimDesafio]="desafio.fimDesafio"
        [porcentagemDesafio]="desafio.porcentagem"
        [desafios]="desafio"
        [desafioId]="desafio.id"
        [linkVamosLa]="desafio.link"
        [caminhoImagem]="desafio.caminhoImagem"
        [caminhoImagemMobile]="desafio.caminhoImagemMobile"
        [idTipo]="desafio.idTipo"
        [membro]="membro"
        [statusId]="desafio.statusId"
        (onDesafioAceito)="aceitarDesafio(i)"
        [descricaoDeAceite]="desafio.descricaoDeAceite"
        [ehMissaoDependente]="desafio.ehMissaoDependente"
        [idGrupoMissaoDependente]="desafio.idGrupoMissaoDependente"
        [countMissoesDependente]="desafio.countMissoesDependente"
        [indexGrupoMissaoDependente]="desafio.indexGrupoMissaoDependente"
        [listaMissoesDependente]="desafio.listaMissoesDependente"
        [exibeCardsMultiplos]="true"
      ></lovers-card-desafio>
    </div>
  </div>

  <div class="experiencias" *ngIf="membro !== undefined && niveis.length > 0">
    <app-experiencias-produto-cs
      (qtdProdutoCS)="quantidadeCardsProdutosCS($event)"
      [niveis]="niveis"
      [idMembro]="membro.idNivel"
      [pontosMembro]="membro.saldo.saldoPontos"
      [membroCPF]="membro.cpf"
      [pontuacaoRestanteProximoNivel]="
        membro.nivelRange.pontosRestantesProximoNivel
      "
      ,
      [pagina]="home"
    >
    </app-experiencias-produto-cs>
  </div>

  <div class="experiencias" *ngIf="membro !== undefined && niveis.length > 0">
    <app-experiencias
      [niveis]="niveis"
      [idMembro]="membro.idNivel"
      [pontosMembro]="membro.saldo.saldoPontos"
      [membroCPF]="membro.cpf"
      [pontuacaoRestanteProximoNivel]="
        membro.nivelRange.pontosRestantesProximoNivel
      "
    ></app-experiencias>
  </div>
</main>
